import { motion } from "framer-motion";
import { TODAY } from "@/lib/data";

const ease = [0.22, 1, 0.36, 1];

export default function TodayMemories() {
  return (
    <section
      data-testid="today-section"
      className="max-w-[1600px] mx-auto px-6 md:px-10 py-20 md:py-28 border-t border-b border-[color:var(--ink-line)]"
    >
      <div className="grid grid-cols-12 gap-6 md:gap-10 items-start">
        <div className="col-span-12 md:col-span-4">
          <div className="overline text-[color:var(--ink-soft)] mb-4">§ Today's Memories</div>
          <h3
            className="font-serif-display leading-[0.95] tracking-tight"
            style={{ fontSize: "clamp(32px, 3.6vw, 54px)" }}
          >
            Observed <span className="font-italic-serif italic">on this day.</span>
          </h3>
          <p className="mt-4 text-[14px] leading-[1.6] text-[color:var(--ink-soft)] max-w-xs">
            Anniversaries, birth dates, memorial candles — a daily ledger
            drawn from families across the archive.
          </p>
        </div>

        <div className="col-span-12 md:col-span-8">
          <div className="rule-strong mb-0" />
          {TODAY.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease }}
              className="grid grid-cols-12 gap-4 py-6 md:py-8 border-b border-[color:var(--ink-line)] items-baseline"
              data-testid={`today-item-${i}`}
            >
              <div className="col-span-2 md:col-span-2 numeric-index text-[color:var(--ink-soft)]">
                {t.date}
              </div>
              <div className="col-span-8 md:col-span-8">
                <p
                  className="font-serif-display leading-[1.15]"
                  style={{ fontSize: "clamp(18px, 1.9vw, 26px)" }}
                >
                  {t.note}
                </p>
              </div>
              <div className="col-span-2 md:col-span-2 numeric-index text-right text-[color:var(--rust)]">
                {t.tag}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
